module.exports = __webpack_public_path__ + "static/img/job@2x.1bc15be6.png";